<template>
  <div class="projectmain-content" v-if="dbData">
    <div class="project-view-container">
        
      <project-view :defaultProps="defaultProps" :projectId="projectId" :project="dbData" :p_login_user_sub="p_login_user_sub" :p_login_tenant="p_login_tenant" :p_login_usertype="p_login_usertype" :p_project_id="projectId" ></project-view>
    </div>
  </div>
</template>

<style>
  .main-content {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .router-content {
    flex: 1 1 auto;
    /* height:100%; */
  }
  .projectmain-content{
    height: 100%;
  }
  .project-view-container {
      width: 100%;
      height: 100%;
      position: relative;
      border:1px solid white;
  }
</style>

<script>
import ProjectView from '@/appViews/Projects/ProjectView'
import ProjectModel from '@/appModel/project/ProjectModel'
import UserModel from "../../appModel/users/UserModel";

export default {
  components: {
    ProjectView
  },
  props: {
    p_login_user_sub: {
      type: String,
      default: "",
    },
    p_login_tenant: {
      type: String,
      default: "",
    },
    p_login_usertype: {
      type: String,
      default: "",
    },
    p_project_sk: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      query:{
        id: ""
      },
      projectId: "",
      isEditName: true,
      //dbdata:{},
      fileList:[],
      dirList:[],
      
      treeData: [
        {
          label: 'プロジェクトルート',
          id: '1',
          type: 'project',
          dirList: [],
          children: []
        }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      dbData: null
    };
  },
  watch: {
    dbData() {
      if (this.dbData) {
        let navInfo = this.$store.state.navInfo
        navInfo.title = this.dbData.project.name
        navInfo.description = ""
        this.$store.commit("setNavInfo", navInfo)
      }
      
    }
  },
  beforeCreate(){
    //インスタンスは生成されたがデータが初期化される前
    //alert(JSON.stringify(this.$store.state.project,null,"\t"))
    //this.dbdata = this.$store.state.project
  },
  created(){    
    //インスタンスが生成され､且つデータが初期化された後
    // this.query.id = this.$route.query.id
    this.getDBData()

  },
  beforeMount(){
    //インスタンスが DOM 要素にマウントされる前
  },
  mounted(){
    //インスタンスが DOM 要素にマウントされた後
    try {
      let project = this.$store.state.project;
      this.projectId = project.project.id

      if (!this.projectId) {
        throw new Error(`プロジェクトID指定なし`)
      }

      this.getDBData().then(function() {
        console.log("")
      })
    } catch (e) {
      console.log(JSON.stringify(e))
      this.$router.push({
        name: 'Projects'
      })
    }
    
  },
  beforeUpdate(){
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount(){
    //Vue インスタンスが破壊される前
  },
  unmounted(){
    //Vue インスタンスが破壊された後

  },
  computed:{
    // dbdata(){
    //   //alert(`${JSON.stringify(this.$store.state.project)}`)
    //   return this.$store.state.project
    // }
    // projectId() {
    //   return this.query.id
    // }
  },
  methods: {
    async getDBData() {
      // ログインユーザー情報取得
      // const userInfo = await UserInfo.getUserInfo();
      const userInfo = await this.$root.getUserInfo()
      // プロジェクト情報取得
      // const data = await ProjectModel.getProject({sk: ProjectModel.createSk(this.query.id)}, userInfo.group)
      const data = await ProjectModel.getProject({sk: ProjectModel.createSk(this.projectId)}, userInfo.group)
      
      console.log(`data:${JSON.stringify(data, null, "\t")}`)
      
      const pk = userInfo.group
      const sk = UserModel.createSk(userInfo.sub)
      const userdbInfo = await UserModel.getUser({pk: pk, sk: sk});
      // console.log(`userdbInfo:${JSON.stringify(userdbInfo, null, "\t")}`);
      if (userdbInfo.user.usertype == "1"){
        this.dbData = data
      } else {
        let judge = false;
        for (let i=0; i<data.project.members.length; i++)
        {
          // console.log(`checkUserID:${data.project.members[i].userId}、${userInfo.sub}`);
          if (data.project.members[i].userId == userInfo.sub){
            judge = true;
            break;
          }
        }
        
        if (judge == true)
        { // 対象の検査個所に遷移          
          this.dbData = data;
        } else {
          // プロジェクトのメンバーに、ログインユーザーがいない場合は、プロジェクト一覧に遷移          
          this.$router.push({
            name: 'Projects'
          })
        }
      }      
    },
    renderContent(h, { node, data, store }) {
      let retObj = null
      switch (data.type) {
      case "project":
        retObj = (
          <span>
            <span class="fa fa-tasks mr-1"></span>{node.data.label}
          </span>
        );
        break
      case "folder":
        retObj = (
          <span>
            <span class="fa fa-folder mr-1"></span>{node.data.label}
          </span>
        );
        break
      default:
        retObj = (
          <span>
            <span class="fa fa-folder mr-1"></span>{node.data.label}
          </span>
        );
      }
      return retObj
    },
    handleNodeClick(data) {
      //alert(JSON.stringify(data));
      
      switch (data.type) {
      case "folder":
        this.fileList = data.fileList
        this.dirList = data.dirList
        break
      default:
        break
      }
    },
  }
};
</script>

<style></style>
